import React from 'react';

export default function Tank28Icon({
  width = 64,
  height = 115,
  startColor = '#1E1E1E',
  midColor = '#BABABA',
  endColor = '#1E1E1E'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 62.777 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_2">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="42.9763" y1="5.2871" x2="52.4255" y2="5.2871">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.45" style={{stopColor: "#BABABA"}} />
		<stop offset="0.55" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.73" style={{stopColor: "#777777"}} />
		<stop offset="0.77" style={{stopColor: "#6D6D6D"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M42.976,0.675h9.449V9.9h-9.449V0.675z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="41.6257" y1="0.6748" x2="53.7761" y2="0.6748">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.45" style={{stopColor: "#BABABA"}} />
		<stop offset="0.55" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.73" style={{stopColor: "#777777"}} />
		<stop offset="0.77" style={{stopColor: "#6D6D6D"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M41.626,0h12.15v1.35h-12.15V0" />
</g>
<g id="Group_1">
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="6.801" y1="90" x2="6.801" y2="73.7998">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.45" style={{stopColor: "#BABABA"}} />
		<stop offset="0.55" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.73" style={{stopColor: "#777777"}} />
		<stop offset="0.77" style={{stopColor: "#6D6D6D"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M1.851,90V73.8h9.9V90H1.851z" />
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="1.3508" y1="92.25" x2="1.3508" y2="71.5498">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.45" style={{stopColor: "#BABABA"}} />
		<stop offset="0.55" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.73" style={{stopColor: "#777777"}} />
		<stop offset="0.77" style={{stopColor: "#6D6D6D"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M0.001,92.25v-20.7h2.7v20.7H0.001" />
</g>
<g id="Group_TankBody">
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="11.2507" y1="55.7544" x2="58.0505" y2="55.7544">
		<stop offset="0" style={{stopColor: "#3A3A3A"}} />
		<stop offset="0.52" style={{stopColor: "#BABABA"}} />
		<stop offset="0.61" style={{stopColor: "#A5A5A5"}} />
		<stop offset="0.82" style={{stopColor: "#707070"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_5_)`} d="M11.251,108.584V10.392l23.4-7.467l23.399,7.467v98.192H11.251z" />
	<radialGradient id={`${id}_6_`} cx="34.6501" cy="6.6709" r="16.7572" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#BABABA"}} />
		<stop offset="0.16" style={{stopColor: "#ACACAC"}} />
		<stop offset="0.47" style={{stopColor: "#868686"}} />
		<stop offset="0.89" style={{stopColor: "#4A4A4A"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</radialGradient>
	<polygon fill={`url(#${id}_6_)`} points="58.051,10.417 58.051,10.35 34.651,2.925 11.251,10.35 11.251,10.417  " />
</g>
<g id="Group_Base">
	<linearGradient id={`${id}_7_`} gradientUnits="userSpaceOnUse" x1="6.5261" y1="110.1377" x2="62.7761" y2="110.1377">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_7_)`} d="M6.526,107.775h56.25v4.725H6.526V107.775z" />
</g>
    
      </g>
      <rect x="0" y="0" width="62.777" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
